<template>
  <div>
    <div
      v-if="showSidebar"
      :class="$forms.overlay"
      @click="hideSidebar"
    />

    <v-navigation-drawer
      :width="width"
      :value="showSidebar"
      right
      fixed>

      <div :class="$style.sidebarContainer">

        <vue-custom-scrollbar class="scroll-area"
                              :settings="settings">

          <h2 :class="[$style.sidebarTitle, getTitleStyle]">{{ sidebarTitle }}</h2>

          <div :class="$style.sidebarContent">
            <slot />
          </div>
        </vue-custom-scrollbar>


        <div :class="[$style.sidebarButtons, getButtonsStyle]">
          <app-button text="Cancel"
                      button-style="default"
                      :class="$style.cancelBtn"
                      @click="hideSidebar($event)"/>

          <app-button text="Save"
                      button-style="accent"
                      :class="$style.saveBtn"
                      :disabled="getFormInvalid || getDisableSaveButton"
                      @click="saveData($event)"/>
        </div>
      </div>

    </v-navigation-drawer>
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  props: {
    width: {
      type: Number,
      default: 600,
    },
    showSidebar: {
      type: Boolean,
      default: false,
    },
    sidebarTitle: {
      type: String,
      default: '',
    },
    formInvalid: {
      type: Boolean,
      default: true,
    },
    titleStyle: {
      type: String,
      default: 'left',
    },
    buttonsStyle: {
      type: String,
      default: 'right',
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        wheelSpeed: 0.5,
      },
    };
  },
  methods: {
    hideSidebar(e) {
      this.$emit('hideSidebar', e);
    },
    saveData(e) {
      this.$emit('saveData', e);
    },
  },
  computed: {
    getFormInvalid() {
      return this.formInvalid;
    },
    getDisableSaveButton() {
      return this.disableButton;
    },
    getTitleStyle() {
      if (this.titleStyle === 'center') {
        return this.$style.centeredTitle;
      }

      return this.$style.leftTitle;
    },
    getButtonsStyle() {
      if (this.buttonsStyle === 'center') {
        return this.$style.centeredButtons;
      }

      return this.$style.rightButtons;
    },
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>
@import "@/styles/variables.scss";

.sidebarContainer {
  height: 100%;
  display: flex;
  flex-direction: column;


  .sidebarTitle {
    margin: 40px 40px 20px;

    &.centeredTitle {
      text-align: center;
    }

    &.leftTitle {
      text-align: left;
    }
  }

  .sidebarContent {
    flex-grow: 1;
    padding: 0 40px;
  }

  .sidebarButtons {
    box-shadow: 0 -1px 3px 0 $light-grey;
    padding: 20px;

    &.centeredButtons {
      text-align: center;
    }

    &.rightButtons {
      text-align: right;
    }

    .cancelBtn,
    .saveBtn {
      margin: 0 12px;
    }

    .cancelBtn {
      padding: 10px 68px;
    }

    .saveBtn {
      padding: 10px 77px;
    }
  }
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.v-navigation-drawer--clipped {

  &:not(.v-navigation-drawer--temporary) {

    &:not(.v-navigation-drawer--is-mobile) {
      z-index: 999;
    }
  }
}

.v-overlay--active {
  pointer-events: none;
}
</style>
